class Node {
    constructor() {
        this.id = null
        this.name = ''
        this.description = ''
        this.parent = ''
        this.datetime_created = ''
        this.datetime_updated = ''
    }

    static get fieldNames() {
        return {
            id: 'ID',
            name: 'Nome',
            description: 'Descrição',
            parent: 'Árvore de Sortimento',
            datetime_created: 'Data de Criação',
            datetime_updated: 'Data de Atualização'
        }
    }

    static get fieldTypes() {
        return {
            id: 'number',
            name: 'text',
            description: 'text',
            parent: 'number',
            datetime_created: 'datetime-local',
            datetime_updated: 'datetime-local'
        }
    }

    static get visibleFields() {
        return {
            id: true,
            name: true,
            description: true,
            parent: true,
            datetime_created: false,
            datetime_updated: false
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            name: true,
            description: true,
            parent: true
            // datetime_created: false
            // datetime_updated: false
        }
    }
}

export default Node

export { Node }
